import { ScanLine } from "lucide-react"

import type { Scene } from "@/lib/domain"
import { cn } from "@/lib/utils"

export function ScenePreview({
  scene,
  className,
  showLabel = true,
}: {
  scene: Scene
  className?: string
  showLabel?: boolean
}) {
  return (
    <div
      className={cn(
        "group/preview relative overflow-hidden rounded-[8px] bg-[#dce8e9]",
        className
      )}
    >
      <img
        src={scene.preview}
        alt={`Synthetic satellite preview of ${scene.location}`}
        className="size-full object-cover transition-[filter,transform] duration-300 ease-out group-hover/preview:scale-[1.015] group-hover/preview:contrast-[1.04]"
      />
      <div className="pointer-events-none absolute inset-0 border border-white/35" />
      {showLabel ? (
        <span className="absolute top-2 left-2 inline-flex items-center gap-1.5 rounded-[6px] bg-[#102f43]/90 px-2 py-1 text-[0.625rem] leading-none font-semibold text-white">
          <ScanLine className="size-3" />
          Synthetic preview
        </span>
      ) : null}
    </div>
  )
}
